module.exports = __webpack_public_path__ + "static/media/mmu_johndalton.b4ff0c01.jpg";